import { Component, OnInit,ViewChild } from '@angular/core';
import { emailVerificationStatus } from '../models/emailVerificationStatus';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-emailverificationenduser',
  templateUrl: './emailverificationenduser.component.html',
  styleUrls: ['./emailverificationenduser.component.css']
})
export class EmailverificationenduserComponent implements OnInit {
emailVerifyObj:emailVerificationStatus
@ViewChild("verifyEmailForm") form: any;

  constructor( private toastr: ToastrManager,private cs:CucurachaAdminService) {
    this.emailVerifyObj=new emailVerificationStatus()
   }
  show:boolean=false
 
  verifyEmailAddress(){
    this.cs.verifyEmailForEndUser(this.emailVerifyObj).subscribe((data) => {

      if (data.STATUS_CODE== 200) {
        this.show=true
        this.toastr.successToastr(data.message);

      }
     
      else {
        this.toastr.errorToastr(data.message);

      }
    })
    
  }
  ngOnInit(): void {
  }
 

}
